import { useMutation } from '@tanstack/react-query';
import { exportSurveyCsv } from '../Services/Surveys.service';
import { useActionToast } from '@/Hooks/useActionToast';

/**
 * Downloads the CSV of one version.
 *
 * A mutation rather than a query because it has a side effect the cache must not replay: the
 * browser saves a file. The object URL is revoked right after the click so the blob is not kept
 * alive for the rest of the session.
 */
export const useExportSurveyCsv = () => {
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, slug, version }: { id: string; slug: string; version?: number }) =>
      exportSurveyCsv(id, slug, version),
    onSuccess: file => {
      const url = URL.createObjectURL(file.blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      toast.success('CSV baixado', file.filename);
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível exportar o CSV', error);
    },
  });
};
